import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { clearState } from "~/store/patient/patientAction";
import { get, find } from "lodash";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PatientForgotCodePageMobile = Loadable({
  loader: () =>
    import(/* mobile" */ "~/components/desktop/pages/PatientForgotCode"),
  loading: LoadableLoading
});
const PatientForgotCodePageDesktop = Loadable({
  loader: () =>
    import(/* desktop" */ "~/components/desktop/pages/PatientForgotCode"),
  loading: LoadableLoading
});
class DetectPatientForgotCode extends Component {
  componentDidMount() {
    this.props.clearState();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PatientForgotCodePageMobile />
        ) : (
          <PatientForgotCodePageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const PatientForgotCodeHelmet = withTitle({
  component: DetectPatientForgotCode,
  title: `${hospitalName.value} | Tìm lại mã số bệnh nhân`
});

export default connect(mapStateToProps, { clearState })(
  PatientForgotCodeHelmet
);
